import { Container, Divider, Grid, Typography } from '@mui/material';
import * as React from 'react'
import FavoriteIcon from '@mui/icons-material/Favorite';

const Footer = () => {
    return (
        <Container disableGutters>
            <Grid container sx={{mt: .5, textAlign: {xs: 'center', sm: 'inherit'}}}>
                <Grid item xs={12} sx={{mb: .5}}>
                    <Divider />
                </Grid>
                <Grid item xs={12} sx={{mb: 1}}>
                    <Typography variant='caption'>&copy; All rights reserved for Javad Koushyar, Made with <FavoriteIcon sx={{width: '15px', verticalAlign: 'middle', color: '#B01E28', pb: 0.5}} /> using <a rel='noreferrer' target='_blank' href="https://react.dev/">React.JS</a></Typography>
                </Grid>
            </Grid>            
        </Container>
    )
};

export default Footer;